import React, { Component, Fragment } from 'react'
import Layout from '../../components/Layout'
import jwt_decode from 'jwt-decode'
import { withStyles } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import InputLabel from '@material-ui/core/InputLabel'
import SplitPane from 'react-split-pane'
import SmartphoneIcon from '@material-ui/icons/PhoneIphone'
import DesktopIcon from '@material-ui/icons/DesktopWindows'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { contentActions, contentVectorizationActions, messageActions } from '../../actions'
import { connect } from 'react-redux'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../utils'
import { readOnly } from '../../utils/permissions'
import Media from 'react-media'
import * as API from '../../api'
import Chip from '@material-ui/core/Chip'
import ChipInput from 'material-ui-chip-input'

import {
  Capitulo,
  Tabela,
  Fluxograma,
  Figura,
  Medicamento,
  Aula,
  Webinar,
  Artigo,
  Podcast,
  Diretriz,
  ConsultaRapidaERecomendacoes,
  DiagnosticoETratamento,
  HabilidadesClinicas
} from './ContentTypes'
import UserToolbar from '../../components/UserToolbar'
import * as ContentType from 'informed-shared/components/es/ContentType'
import {
  ContentVideo,
  ContentAudio,
  ContentImage,
  ContentHtml,
  ContentDiretriz
} from 'informed-shared/components/es/Content'

import Input from '@material-ui/core/Input'

const TEXTUAL_VECTORIZATION_TYPES = [
  'artigo',
  'capitulo',
  'consulta_rapida_e_recomendacoes',
  'diagnostico_e_tratamento',
  'diretriz',
  'medicamento'
]

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  wrapperButton: {
    position: 'relative'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  contentFormWrapper: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'auto'
  },
  contentForm: {
    padding: theme.spacing.unit * 3
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '14px 0'
  },
  actionBarWrapper: {
    position: 'absolute',
    bottom: 0,
    padding: `12px ${theme.spacing.unit * 3}px`,
    justifyContent: 'flex-end',
    display: 'flex',
    left: 0,
    right: 0
  },
  actionBarButton: {
    marginLeft: '12px'
  },
  previewArea: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.6em'
  },
  previewAreaWrapper: {
    height: 'calc(100% - 60px)',
    overflow: 'auto'
  }
})

class Content extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mobilePreview: false,
      previewAreaClasses: 'ContentPreview',
      previewIsOpen: false,
      vectorizationSubmitting: false
    }

    this.ContentPreviewRef = React.createRef()
    this.ContentPreviewMobileRef = React.createRef()
  }

  componentDidMount() {
    const { match = {} } = this.props
    const { params = {} } = match

    if (params.id && params.id !== 'novo') {
      this.props.fetchContent(params.id)
    } else if (params.id === 'novo') {
      this.props.newContent()
    }

    window.addEventListener('resize', this.handleChangeWidth, false)
    this.handleChangeWidth()
  }

  getVectorizationSelectLabels = values => {
    return formatContentSelectValue(values || [])
      .map(item => item.label)
      .filter(Boolean)
  }

  buildVectorizationPayload = (savedContent, formContent) => {
    const content = { ...(formContent || {}), ...(savedContent || {}) }
    const conteudoHtml =
      (savedContent || {}).conteudoHtml ||
      (formContent || {}).conteudoHtml ||
      this.props.conteudoHtml ||
      ''
    const titulo =
      content.titulo ||
      content.principioAtivo ||
      content.tituloCapitulo ||
      content.tituloArtigo ||
      content.tituloDeT ||
      content.descricao ||
      content.codigo ||
      ''

    if (!conteudoHtml) {
      throw new Error('O CMS não retornou o HTML processado para a vetorização.')
    }

    if (!content._id) {
      throw new Error('O CMS não retornou o identificador do conteúdo salvo.')
    }

    const payload = {
      tipo: content.tipo,
      titulo,
      content_id: String(content._id),
      conteudoHtml
    }
    const autores = this.getVectorizationSelectLabels((formContent || {}).autores || [])
    const especialidades = this.getVectorizationSelectLabels(
      (formContent || {}).especialidades || []
    )
    const ano =
      content.anoPublicacao ||
      content.anoPublicacaoArtigo ||
      content.anoPublicacaoDeT ||
      content.copyrightLivro

    if (autores.length) payload.autores = autores
    if (especialidades.length) payload.especialidade = especialidades[0]
    const parsedYear = parseInt(ano, 10)
    if (!Number.isNaN(parsedYear)) payload.ano = parsedYear
    if (content.isbn) payload.isbn = content.isbn

    return payload
  }

  vectorizeSavedContent = (savedContent, formContent) => {
    let payload

    try {
      payload = this.buildVectorizationPayload(savedContent, formContent)
    } catch (err) {
      return Promise.reject(err)
    }

    this.setState({ vectorizationSubmitting: true })
    return this.props
      .addContentToVectorization(payload)
      .then(result => {
        this.setState({ vectorizationSubmitting: false })
        return result
      })
      .catch(err => {
        this.setState({ vectorizationSubmitting: false })
        return Promise.reject(err)
      })
  }

  handleSave = (content, vectorizeAfterSave = false) => {
    const { addContent, editContent, changeMessage } = this.props
    if (content._id) {
      editContent(content)
        .then(() => {
          changeMessage({ message: 'Alteração realizada com sucesso.' })
          this.props.history.push('/conteudos')
        })
        .catch(err => {
          const { response = {} } = err
          const { data = {} } = response
          if (data === 'IvalidHtmlContent') {
            changeMessage({ message: 'O conteúdo possui estilos inválidos.' })
          } else {
            changeMessage({ message: 'Falha ao salvar conteúdo.' })
          }
        })
    } else {
      addContent(content)
        .then(savedContent => {
          if (!vectorizeAfterSave) {
            changeMessage({ message: 'Cadastro realizado com sucesso.' })
            this.props.history.push('/conteudos')
            return
          }

          this.vectorizeSavedContent(savedContent, content)
            .then(() => {
              changeMessage({
                message: 'Conteúdo salvo no CMS e enviado para vetorização com sucesso.'
              })
              this.props.history.push('/conteudos-vetorizados')
            })
            .catch(() => {
              changeMessage({
                message:
                  'O conteúdo foi salvo no CMS, mas não pôde ser enviado para vetorização. O cadastro foi preservado.',
                type: 'error'
              })
              this.props.history.push('/conteudos')
            })
        })
        .catch(err => {
          const { response = {} } = err
          const { data = {} } = response
          if (data === 'IvalidHtmlContent') {
            changeMessage({ message: 'O conteúdo possui estilos inválidos.' })
          } else {
            changeMessage({ message: 'Falha ao salvar conteúdo.' })
          }
        })
    }
  }

  handleSubmit = (e, content, vectorizeAfterSave = false) => {
    e.preventDefault()

    const { setContentFormTouched } = this.props

    if (this.props.contentFormErrors.valid) {
      this.handleSave(content, vectorizeAfterSave)
    } else {
      setContentFormTouched()
    }

    return false
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleChangeWidth, false)
  }

  componentDidUpdate(props, state) {
    if (state.mobilePreview !== this.state.mobilePreview) {
      this.handleChangeWidth()
    }
  }

  handleChangeWidth = () => {
    let previewAreaClasses = 'ContentPreview'

    const previewAreaDesktopWidth = this.ContentPreviewRef.current
      ? this.ContentPreviewRef.current.offsetWidth
      : ''

    const previewAreaMobileWidth = this.ContentPreviewMobileRef.current
      ? this.ContentPreviewMobileRef.current.offsetWidth
      : ''

    const previewAreaWidth = previewAreaMobileWidth || previewAreaDesktopWidth

    if (!previewAreaWidth) {
      return false
    }

    if (this.state.mobilePreview) {
      previewAreaClasses = `${previewAreaClasses} ContentPreview-area-mobile`
    }

    if (previewAreaWidth >= 600) {
      previewAreaClasses = `${previewAreaClasses} ContentPreview-min-600`
    }

    if (previewAreaWidth < 600) {
      previewAreaClasses = `${previewAreaClasses} ContentPreview-max-599`
    }

    if (previewAreaWidth >= 800) {
      previewAreaClasses = `${previewAreaClasses} ContentPreview-min-800`
    }

    this.ContentPreviewRef.current.style.setProperty(
      '--content-preview-width',
      `${previewAreaWidth}px`
    )

    this.setState({
      previewAreaClasses
    })
  }

  toggleDevice = () => {
    this.setState(state => {
      let previewAreaClasses = state.previewAreaClasses.replace('ContentPreview-area-mobile', '')
      previewAreaClasses = state.mobilePreview
        ? previewAreaClasses
        : `${previewAreaClasses} ContentPreview-area-mobile`
      return {
        mobilePreview: !state.mobilePreview,
        previewAreaClasses
      }
    })
  }

  formattedNewArray = (aux = []) => {
    aux.map(item => {
      return {
        value: item
      }
    })
  }

  handleAddPalavrasChave = keyword => {
    const { content = '', handleChangeContent } = this.props
    let buscaKeywords = content.buscaPalavrasChave || []

    const duplicated = buscaKeywords.find(
      item => item.trim().toLowerCase() === keyword.trim().toLowerCase()
    )

    buscaKeywords = duplicated ? buscaKeywords : [...buscaKeywords, keyword]

    handleChangeContent({ ...content, buscaPalavrasChave: buscaKeywords || [] })
  }

  handleDeletePalavrasChave = async keyword => {
    const { content = '' } = this.props
    let buscaKeywords = content.buscaPalavrasChave || []

    buscaKeywords = buscaKeywords.filter(item => item !== keyword)

    if (buscaKeywords.length <= 0) {
      await this.props.handleChangeContent({
        ...content,
        buscaPalavrasChave: buscaKeywords || [],
        buscaPeso: ''
      })
    } else {
      await this.props.handleChangeContent({ ...content, buscaPalavrasChave: buscaKeywords || [] })
    }
  }

  renderContentToolBar = () => {
    return (
      <Fragment>
        <UserToolbar />

        <Media query={'(min-width: 960px)'}>
          <IconButton color="inherit" onClick={this.toggleDevice}>
            {this.state.mobilePreview ? <DesktopIcon /> : <SmartphoneIcon />}
          </IconButton>
        </Media>
      </Fragment>
    )
  }

  renderCommonFields = () => {
    const {
      classes,
      content,
      handleChangeContent,
      formTouched,
      contentFormErrors,
      token
    } = this.props

    if (!content.tipo || !((contentFormErrors.fields || {})['tipo'] || {}).valid) return null

    const isReadOnly = readOnly(content.tipo, token)

    return (
      <React.Fragment>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            className={classes.formControl}
            onChange={e => {
              handleChangeContent({ ...content, grupoConteudo: e })
            }}
            error={!((contentFormErrors.fields || {})['grupoConteudo'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.grupoConteudo || [])}
            placeholder="Selecione..."
            name="react-select-chip-grupoContent"
            label="Grupo de Conteúdo"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-grupoContent',
                options: [],
                loadOptions: API.gruposConteudo.getSelectGruposConteudo
              }
            }}
          />
          {!((contentFormErrors.fields || {})['gruposConteudo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['gruposConteudo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>

        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            className={classes.formControl}
            onChange={e => {
              handleChangeContent({ ...content, publicoAlvo: e })
            }}
            error={!((contentFormErrors.fields || {})['publicoAlvo'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.publicoAlvo || [])}
            placeholder="Selecione..."
            name="react-select-chip-publicoAlvo"
            label="Público-alvo"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-publicoAlvo',
                options: [],
                loadOptions: API.publicosAlvo.getSelectPublicosAlvo
              }
            }}
          />
          {!((contentFormErrors.fields || {})['publicoAlvo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['publicoAlvo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>

        <div className={classes.formControl}>
          <fieldset>
            <legend>Busca</legend>
            <FormControl className={classes.formControl} fullWidth>
              <ChipInput
                disabled={isReadOnly}
                id="field-buscaPalavrasChave"
                value={
                  (content.buscaPalavrasChave || []).map(item => {
                    return item
                  }) || []
                }
                label={'Palavras-Chave'}
                inputProps={{
                  form: 'non-form'
                }}
                onAdd={this.handleAddPalavrasChave}
                onDelete={this.handleDeletePalavrasChave}
                chipRenderer={(
                  { value, text, isFocused, isDisabled, handleClick, handleDelete, className },
                  key
                ) => (
                  <Chip
                    key={key}
                    className={className}
                    style={{
                      pointerEvents: isDisabled ? 'none' : undefined,
                      backgroundColor: isFocused ? 'black' : undefined
                    }}
                    onClick={handleClick}
                    onDelete={isDisabled ? null : handleDelete}
                    label={text}
                  />
                )}
              />
            </FormControl>

            {(content.buscaPalavrasChave || []).length !== 0 && (
              <FormControl
                className={classes.formControl}
                error={!((contentFormErrors.fields || {})['buscaPeso'] || {}).valid && formTouched}
                fullWidth
              >
                <InputLabel htmlFor="field-buscaPeso">Peso</InputLabel>
                <Input
                  disabled={isReadOnly}
                  fullWidth
                  required={'false'}
                  type="number"
                  onChange={e => {
                    handleChangeContent({ ...content, buscaPeso: e.target.value })
                  }}
                  value={content.buscaPeso || ''}
                  id="field-buscaPeso"
                />
                {!((contentFormErrors.fields || {})['buscaPeso'] || {}).valid && formTouched ? (
                  <Typography className={classes.errorMessage} noWrap color={'error'}>
                    {((contentFormErrors.fields || {})['buscaPeso'] || {}).errorMessage}
                  </Typography>
                ) : null}
              </FormControl>
            )}
          </fieldset>
        </div>
      </React.Fragment>
    )
  }

  contentTypes = () => {
    const { token } = this.props
    const userToken = jwt_decode(token)

    const types = [
      { name: 'Artigo', value: 'artigo' },
      { name: 'Aula', value: 'aula' },
      { name: 'Capítulo', value: 'capitulo' },
      { name: 'Consulta rápida e recomendações', value: 'consulta_rapida_e_recomendacoes' },
      { name: 'Diagnóstico e tratamento', value: 'diagnostico_e_tratamento' },
      { name: 'Diretriz', value: 'diretriz' },
      { name: 'Ficha de medicamento', value: 'medicamento' },
      { name: 'Figura', value: 'figura' },
      { name: 'Fluxograma', value: 'fluxograma' },
      { name: 'Habilidades Clínicas', value: 'habilidades_clinicas' },
      { name: 'Tabela', value: 'tabela' },
      { name: 'Podcast', value: 'podcast' },
      { name: 'Webinar', value: 'webinar' }
    ]

    if (!userToken) {
      return []
    }

    return userToken.user.perfil.permissoes.reduce((previous, current) => {
      const { alias } = current.funcionalidade

      if (/conteudos-/.test(alias)) {
        return [...previous, types.find(item => item.value === alias.replace(/conteudos-/, ''))]
      }

      return [...previous]
    }, [])
  }

  renderContentForm = () => {
    const { contentTypes } = this
    const {
      classes,
      content,
      handleChangeContent,
      formTouched,
      contentFormErrors,
      location
    } = this.props
    const openedFromVectorization = ((location || {}).search || '').includes('vectorizar=1')

    return (
      <form
        noValidate
        onSubmit={e => {
          this.handleSubmit(e, content)
        }}
        id="content-form"
        className={classes.contentFormWrapper}
      >
        <div className={classes.contentForm}>
          {openedFromVectorization && !content._id ? (
            <div
              style={{
                border: '1px solid #d8e5f3',
                borderRadius: 4,
                backgroundColor: '#f5f9fd',
                padding: '12px 16px',
                marginBottom: 16
              }}
            >
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Cadastro e vetorização de conteúdo
              </Typography>
              <Typography variant="caption" color="textSecondary">
                O CMS processa e permite revisar o HTML. Depois de salvar, esse mesmo HTML será
                enviado ao Sniper para vetorização, sem repetir o cadastro.
              </Typography>
            </div>
          ) : null}

          <FormControl
            error={!((contentFormErrors.fields || {})['tipo'] || {}).valid && formTouched}
            fullWidth
            className={classes.formControl}
          >
            <InputLabel htmlFor="content-type">Tipo de conteúdo</InputLabel>
            <Select
              id="content-type"
              value={content.tipo}
              disabled={!!content._id}
              onChange={e => {
                handleChangeContent({ ...content, tipo: e.target.value })
              }}
            >
              {contentTypes().map(item => {
                return (
                  <MenuItem key={(item || {}).value} value={(item || {}).value}>
                    {(item || {}).name}
                  </MenuItem>
                )
              })}
            </Select>
            {!((contentFormErrors.fields || {})['tipo'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tipo'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>

          <ContentType.Render type={content.tipo} types={['capitulo']}>
            <Capitulo />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['tabela']}>
            <Tabela />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['fluxograma']}>
            <Fluxograma />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['figura']}>
            <Figura />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['medicamento']}>
            <Medicamento />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['aula']}>
            <Aula />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['habilidades_clinicas']}>
            <HabilidadesClinicas />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['webinar']}>
            <Webinar />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['artigo']}>
            <Artigo />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['podcast']}>
            <Podcast />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['diretriz']}>
            <Diretriz />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['consulta_rapida_e_recomendacoes']}>
            <ConsultaRapidaERecomendacoes />
          </ContentType.Render>

          <ContentType.Render type={content.tipo} types={['diagnostico_e_tratamento']}>
            <DiagnosticoETratamento />
          </ContentType.Render>

          {this.renderCommonFields()}
        </div>
      </form>
    )
  }

  renderFormSpinner = () => {
    const { classes } = this.props
    return (
      <div className={classes.wrapperLoader}>
        <CircularProgress />
      </div>
    )
  }

  renderContentPreviewMobile = () => {
    return this.state.mobilePreview ? (
      <div className={'ContentPreview-mobile'} ref={this.ContentPreviewMobileRef}>
        {this.renderContentPreview()}
      </div>
    ) : (
      this.renderContentPreview()
    )
  }

  renderContentPreview = () => {
    const { classes, content, conteudoHtml, loadingHtmlPreview } = this.props

    const previewAutores = formatContentSelectValue(content.autores || [])
      .map(item => {
        return item.label
      })
      .join(', ')

    return (
      <Fragment>
        <ContentType.RenderUnlessType type={content.tipo}>
          <div className={classes.previewArea}>Pré-visualização</div>
        </ContentType.RenderUnlessType>
        <ContentType.Render type={content.tipo} types={['aula', 'webinar', 'habilidades_clinicas']}>
          {content.codigo ||
          content.titulo ||
          content.tituloCurso ||
          previewAutores ||
          content.descricao ? (
            <div className={classes.previewAreaContent}>
              <ContentVideo
                content={content}
                player={content.tipo === 'webinar' ? 'youtube' : 'vimeo'}
              />
            </div>
          ) : (
            <div className={classes.previewArea}>Pré-visualização</div>
          )}
        </ContentType.Render>

        <ContentType.Render type={content.tipo} types={['podcast']}>
          {content.codigo ||
          content.titulo ||
          content.tituloCurso ||
          previewAutores ||
          content.descricao ? (
            <div className={classes.previewAreaContent}>
              {(content.codigo || '').includes('soundcloud') ? (
                <ContentAudio content={content} player={'soundcloud'} />
              ) : (
                <ContentVideo content={content} player={'vimeo'} />
              )}
            </div>
          ) : (
            <div className={classes.previewArea}>Pré-visualização</div>
          )}
        </ContentType.Render>

        <ContentType.Render type={content.tipo} types={['figura', 'tabela', 'fluxograma']}>
          {content.titulo || content.descricao || previewAutores || content.url ? (
            <div className={classes.previewAreaContent}>
              <ContentImage content={content} />
            </div>
          ) : (
            <div className={classes.previewArea}>Pré-visualização</div>
          )}
        </ContentType.Render>

        <ContentType.Render
          type={content.tipo}
          types={[
            'medicamento',
            'capitulo',
            'artigo',
            'consulta_rapida_e_recomendacoes',
            'diagnostico_e_tratamento'
          ]}
        >
          {!!conteudoHtml ||
          content.conteudoHtml ||
          loadingHtmlPreview ||
          previewAutores ||
          content.principioAtivo ||
          content.titulo ? (
            loadingHtmlPreview ? (
              this.renderFormSpinner()
            ) : (
              <Fragment>
                <ContentHtml content={content} contentPreview={conteudoHtml} />
              </Fragment>
            )
          ) : (
            <div className={classes.previewArea}>Pré-visualização</div>
          )}
        </ContentType.Render>

        <ContentType.Render type={content.tipo} types={['diretriz']}>
          {!!conteudoHtml ||
          content.conteudoHtml ||
          loadingHtmlPreview ||
          content.subtitulo ||
          content.instituicao ||
          content.autoresDiretriz ||
          content.titulo ? (
            loadingHtmlPreview ? (
              this.renderFormSpinner()
            ) : (
              <Fragment>
                <ContentDiretriz content={content} contentPreview={conteudoHtml} />
              </Fragment>
            )
          ) : (
            <div className={classes.previewArea}>Pré-visualização</div>
          )}
        </ContentType.Render>
      </Fragment>
    )
  }

  onClose = () => {
    this.setState({
      previewIsOpen: false
    })
  }

  openPreviewModal = () => {
    this.setState({
      previewIsOpen: true
    })
  }

  render() {
    const {
      handleChangeWidth,
      renderContentForm,
      renderFormSpinner,
      renderContentPreviewMobile,
      renderContentPreview
    } = this

    const { classes, loadingContent, newContent, token, content } = this.props

    this.ContentPreviewRef.current &&
      this.ContentPreviewRef.current.style.setProperty('--content-base-font-size', '0.7rem')

    const { previewAreaClasses, vectorizationSubmitting } = this.state
    const isReadOnly = readOnly(content.tipo, token)
    const isSaving = loadingContent || vectorizationSubmitting
    const canVectorize =
      !content._id && TEXTUAL_VECTORIZATION_TYPES.includes(content.tipo)

    return (
      <Layout
        safeArea={false}
        toolBarRight={() => {
          return this.renderContentToolBar()
        }}
      >
        <Media query={'(min-width: 960px)'}>
          <div className={classes.layout}>
            <SplitPane onChange={handleChangeWidth} split="vertical" minSize={50} defaultSize={100}>
              {!loadingContent ? renderContentForm() : renderFormSpinner()}
              <div className={previewAreaClasses} ref={this.ContentPreviewRef}>
                {!loadingContent ? renderContentPreviewMobile() : renderFormSpinner()}
                <Paper className={classes.actionBarWrapper}>
                  <Button
                    component={Link}
                    to={'/conteudos'}
                    color="default"
                    onClick={newContent}
                    className={classes.actionBarButton}
                  >
                    {isReadOnly ? 'Voltar' : 'Cancelar'}
                  </Button>
                  <div className={classes.wrapperButton}>
                    {!isReadOnly && (
                      <Fragment>
                        <Button
                          form={'content-form'}
                          type={'submit'}
                          disabled={isSaving}
                          className={classes.actionBarButton}
                          color="primary"
                          variant="raised"
                        >
                          Salvar
                        </Button>
                        {!content._id ? (
                          <Button
                            type="button"
                            disabled={isSaving || !canVectorize}
                            className={classes.actionBarButton}
                            color="primary"
                            variant="raised"
                            onClick={e => this.handleSubmit(e, content, true)}
                          >
                            {vectorizationSubmitting
                              ? 'Enviando ao Sniper...'
                              : 'Salvar no CMS e vetorizar'}
                          </Button>
                        ) : null}
                        {isSaving && (
                          <CircularProgress size={24} className={classes.buttonProgress} />
                        )}
                      </Fragment>
                    )}
                  </div>
                </Paper>
              </div>
            </SplitPane>
          </div>
        </Media>
        <Media query={'(max-width: 959px)'}>
          <div className={classes.layout}>
            <div className={classes.previewAreaWrapper}>
              {!loadingContent ? renderContentForm() : renderFormSpinner()}
              <Paper className={classes.actionBarWrapper}>
                <Button
                  component={Link}
                  to={'/conteudos'}
                  color="default"
                  onClick={newContent}
                  className={classes.actionBarButton}
                >
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                <Button onClick={this.openPreviewModal} color="primary" variant="raised">
                  Visualizar
                </Button>
              </Paper>
            </div>
            <Dialog
              modalId="conteudos-pre-visualizacao-mobile"
              modalParams={{ registro: content._id, tipo: content.tipo }}
              fullScreen={true}
              fullWidth
              open={this.state.previewIsOpen}
              onClose={this.onClose}
              className={classes.dialog}
            >
              <Fragment>
                <DialogTitle id="conteudos-pre-visualizacao-mobile-title">
                  Conteúdos — Pré-visualização móvel
                </DialogTitle>
                <DialogContent>
                  <div
                    className={`${
                      window.innerWidth <= 600
                        ? `ContentPreview-responsive ${previewAreaClasses}`
                        : previewAreaClasses
                    }`}
                    ref={this.ContentPreviewRef}
                  >
                    {!loadingContent ? renderContentPreview() : renderFormSpinner()}
                  </div>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.onClose}
                    color="default"
                    className={classes.actionBarButton}
                  >
                    Voltar
                  </Button>
                  <div className={classes.wrapperButton}>
                    {!isReadOnly && (
                      <Fragment>
                        <Button
                          form={'content-form'}
                          type={'submit'}
                          disabled={isSaving}
                          className={classes.actionBarButton}
                          color="primary"
                          variant="raised"
                        >
                          Salvar
                        </Button>
                        {!content._id ? (
                          <Button
                            type="button"
                            disabled={isSaving || !canVectorize}
                            className={classes.actionBarButton}
                            color="primary"
                            variant="raised"
                            onClick={e => this.handleSubmit(e, content, true)}
                          >
                            {vectorizationSubmitting
                              ? 'Enviando ao Sniper...'
                              : 'Salvar no CMS e vetorizar'}
                          </Button>
                        ) : null}
                        {isSaving && (
                          <CircularProgress size={24} className={classes.buttonProgress} />
                        )}
                      </Fragment>
                    )}
                  </div>
                </DialogActions>
              </Fragment>
            </Dialog>
          </div>
        </Media>
      </Layout>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchContent: id => {
      dispatch(contentActions.fetchContent(id))
    },
    fetchContents: ({ page, perPage }) => {
      dispatch(contentActions.fetchContents({ page, perPage }))
    },
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    deleteContent: id => {
      dispatch(contentActions.deleteContent(id))
    },
    restoreContent: id => {
      dispatch(contentActions.restoreContent(id))
    },
    addContent: content => {
      return dispatch(contentActions.addContent(content))
    },
    changeMessage: ({ message, anchorOrigin, type }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin, type }))
    },
    editContent: content => {
      return dispatch(contentActions.editContent(content))
    },
    newContent: () => {
      dispatch(contentActions.newFormContent())
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    },
    clearBuscaPeso: () => {
      return dispatch(contentActions.clearBuscaPeso())
    },
    addContentToVectorization: content => {
      return dispatch(contentVectorizationActions.addConteudo(content))
    }
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contents: state.content.contents,
    loadingContents: state.content.loadingContents,
    loadingHtmlPreview: state.content.loadingHtmlPreview,
    loadingContent: state.content.loadingContent,
    contentFormErrors: state.content.contentFormErrors,
    conteudoHtml: state.content.conteudoHtml,
    formTouched: state.content.contentFormTouched,
    token: state.auth.token,
    pagination: state.content.contentsPagination
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(Content)))



// WEBPACK FOOTER //
// ./src/containers/Content/editForm.js